import Alert from 'react-bootstrap/Alert';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { LoginForm } from './forms/LoginForm';

import { logIn, selectUser } from './userSlice';

export function Login() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  if (user.isLoggedIn) {
    return <Redirect to="/admin" />;
  }

  return (
    <Row className="justify-content-center">
      <Col md={4}>
        <h4>Đăng nhập</h4>
        <hr />
        <LoginForm
          alert={
            user.errorMessage && (
              <Alert variant="danger">{user.errorMessage}</Alert>
            )
          }
          onSubmit={(data) => dispatch(logIn(data))}
          values={{ email: '', password: '' }}
        />
      </Col>
    </Row>
  );
}
